/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { PageIcon, PageIconType } from "@/types";
import CanvasManager from "./CanvasManager";
import { IconInitializer } from "../icons";
import StrategyManager from "./StrategyManager";
import { ImageManager } from "./ImageManager";

class IconManager {
  private canvasManager: CanvasManager;
  private iconInitializer: IconInitializer;
  private imageManager: ImageManager;
  private strategyManager: StrategyManager;
  private onIconClicked: (icon: PageIcon) => void;
  private onNotePositionChanged: ({
    id,
    x,
    y,
  }: {
    id: string;
    x: number;
    y: number;
  }) => void;

  constructor(
    canvasManager: CanvasManager,
    imageManager: ImageManager,
    strategyManager: StrategyManager,
    onOnIconClicked: (icon: PageIcon) => void,
    onNotePositionChanged: ({
      id,
      x,
      y,
    }: {
      id: string;
      x: number;
      y: number;
    }) => void
  ) {
    this.canvasManager = canvasManager;
    this.iconInitializer = new IconInitializer();
    this.strategyManager = strategyManager;
    this.imageManager = imageManager;
    this.onIconClicked = onOnIconClicked.bind(this); // Bağlamı sabitleyin
    this.onNotePositionChanged = onNotePositionChanged.bind(this); // Bağlamı sabitleyin
  }

  async loadIcons(canvasHeight: number): Promise<void> {
    this.iconInitializer.initIcons(canvasHeight);
  }

  private handleShowGapFilling(icon: PageIcon): void {
    const gapFillingStrategy =
      this.strategyManager.getStrategy("OpenGapFilling");
    gapFillingStrategy?.execute(
      icon,
      this.canvasManager,
      this.imageManager,
      this
    );
  }

  private handleCloseGapFilling(icon: PageIcon): void {
    const closeGapFillingStrategy =
      this.strategyManager.getStrategy("CloseGapFilling");
    closeGapFillingStrategy?.execute(
      icon,
      this.canvasManager,
      this.imageManager,
      this
    );
  }

  private handleShowQuestionAnswer(icon: PageIcon): void {
    const showQuestionAnswerStrategy =
      this.strategyManager.getStrategy("OpenQuestionAnswer");
    showQuestionAnswerStrategy?.execute(
      icon,
      this.canvasManager,
      this.imageManager,
      this
    );
  }

  private handleCloseQuestionAnswer(icon: PageIcon): void {
    const closeQuestionAnswerStrategy = this.strategyManager.getStrategy(
      "CloseQuestionAnswer"
    );
    closeQuestionAnswerStrategy?.execute(
      icon,
      this.canvasManager,
      this.imageManager,
      this
    );
  }

  iconMouseDownBefore(icon: PageIcon): void {
    this.canvasManager.closeDrawingMode();
  }
  iconMouseDown(icon: PageIcon): void {
    if (icon.isUserContent !== true) {
      switch (icon.type) {
        case PageIconType.Question:
        case PageIconType.Interacts:
          this.onIconClicked(icon);
          break;
        case PageIconType.Sound:
        case PageIconType.Video:
        case PageIconType.Url:
        case PageIconType.Image:
        case PageIconType.TextNote:
        case PageIconType.File:
        case PageIconType.Drawing:
        case PageIconType.Games:
          this.onIconClicked(icon);
          break;
        case PageIconType.ShowGapFillingItem:
          this.handleShowGapFilling(icon);
          break;
        case PageIconType.CloseGapFillingItem:
          this.handleCloseGapFilling(icon);
          break;
        case PageIconType.ShowQuestionAnswer:
          this.handleShowQuestionAnswer(icon);
          break;
        case PageIconType.QuestionAnswer:
          this.handleCloseQuestionAnswer(icon);
          break;
        default:
          console.warn(`Unhandled icon type: ${icon.type}`);
      }
    }
  }
  iconMouseUp(icon: any, pageIcon: PageIcon, isDragged: boolean): void {
    this.canvasManager.openDrawingMode();
    if (pageIcon.isUserContent === true) {
      const endLeft: number = icon.left;
      const endTop: number = icon.top;
      if (isDragged) {
        this.onNotePositionChanged({ id: pageIcon.id, x: endLeft, y: endTop });
      } else {
        this.onIconClicked(pageIcon);
      }
    }
  }

  addIcon(
    imageLeft: number,
    imageTop: number,
    pageIcon: PageIcon,
    callback?: (icon: any) => void
  ): void {
    this.iconInitializer.getIcon(imageLeft, imageTop, pageIcon, (iconImage) => {
      let startLeft = 0;
      let startTop = 0;
      this.canvasManager.addObject(iconImage);
      iconImage.on("mousedown:before", () => {
        this.iconMouseDownBefore(pageIcon);
      });
      iconImage.on("mousedown", () => {
        startLeft = iconImage.left;
        startTop = iconImage.top;
        this.iconMouseDown(pageIcon);
      });
      iconImage.on("mouseup", (e: any) => {
        const endLeft = iconImage.left;
        const endTop = iconImage.top;
        const isDragged = startLeft !== endLeft || startTop !== endTop;

        this.iconMouseUp(iconImage, pageIcon, isDragged);
      });
      callback?.(iconImage);
    });
  }

  hideIconById(id: string): void {
    const icons = this.canvasManager.getObjectsById(id);
    icons.forEach((icon) => (icon.visible = false));
  }
  showIconById(id: string): void {
    const icons = this.canvasManager.getObjectsById(id);
    icons.forEach((icon) => (icon.visible = true));
  }

  removeIconById(id: string): void {
    const icons = this.canvasManager.getObjectsById(id);
    icons.forEach((icon) => this.canvasManager.removeObject(icon));
  }
}

export default IconManager;
